export class FunderSettings {
  individual_members_billing_date_of_month?: number;
  individual_members_billing_time_of_day?: string;
  should_send_member_first_billing_message?: boolean;
  member_first_billing_message_date_of_month?: number;
  member_first_billing_message_time_of_day?: string;
  should_send_member_second_billing_message?: boolean;
  member_second_billing_message_date_of_month?: number;
  member_second_billing_message_time_of_day?: string;
  should_send_member_third_billing_message?: boolean;
  member_third_billing_message_date_of_month?: number;
  member_third_billing_message_time_of_day?: string;
  corporate_members_billing_date_of_month?: number;
  corporate_members_billing_time_of_day?: string;
  should_send_company_first_billing_message?: boolean;
  company_first_billing_message_date_of_month?: number;
  company_first_billing_message_time_of_day?: string;
  should_send_company_second_billing_message?: boolean;
  company_second_billing_message_date_of_month?: number;
  company_second_billing_message_time_of_day?: string;
  should_send_company_third_billing_message?: boolean;
  company_third_billing_message_date_of_month?: number;
  company_third_billing_message_time_of_day?: string;
  company_interim_statements_date_of_month?: number;
  company_interim_statements_time_of_day?: string;
  should_send_company_first_interim_statement_message?: boolean;
  company_first_interim_statement_message_date_of_month?: number;
  company_first_interim_statement_message_time_of_day?: string;
  should_send_company_second_interim_statement_message?: boolean;
  company_second_interim_statement_message_date_of_month?: number;
  company_second_interim_statement_message_time_of_day?: string;
  should_send_company_third_interim_statement_message?: boolean;
  company_third_interim_statement_message_date_of_month?: number;
  company_third_interim_statement_message_time_of_day?: string;
  should_send_dependent_birthday_message?: boolean;
  dependent_birthday_message_time_of_day?: string;
  // can_submit_claims toggles live on Scheme. The funder-wide copies
  // that used to be here were dead code on the backend. Kept on the
  // type as `?` so old API responses with the column populated still
  // deserialize cleanly.
  corporate_members_can_submit_claims?: boolean;
  individual_members_can_submit_claims?: boolean;
  allows_individual_members_backdating?: boolean;
  allows_corporate_members_backdating?: boolean;
  // Day-of-month threshold for the receipt-driven effective-date rule
  // (default 17, configurable 1..28). Drives the new logic that defers
  // effective_date until the first APPROVED contribution receipt.
  effective_date_cutoff_day_of_month?: number;
  // Stage 5 PR 100, 2026-06-04 — lapsing controls.
  // lapse_after_months: months a member/company can stay SUSPENDED
  // before LAPSE (default 3 ≈ 90 days). Read by the daily lapse jobs
  // + the Corporate/Individual Lapsing pages.
  lapse_after_months?: number;
  // Auto-execute opt-ins (default true). false = the daily job only
  // identifies candidates; operator lapses manually from the pages.
  corporate_lapsing_auto_execute?: boolean;
  individual_lapsing_auto_execute?: boolean;
  // Stage 2 PR 5 — Duplicate Claim Detection Window, 2026-05-14. Read
  // by the DuplicateClaimDetector at claim store-time (PR 4C). 0
  // disables detection entirely; default 7 days; range 0..90.
  duplicate_claim_window_days?: number;
  domain?: string;
  uuid!: string;
  date_deleted?: number | null;
  date_created!: number;
  date_updated!: number;

  constructor(data: any) {
    this.individual_members_billing_date_of_month = data.individual_members_billing_date_of_month;
    this.individual_members_billing_time_of_day = data.individual_members_billing_time_of_day;
    this.should_send_member_first_billing_message = data.should_send_member_first_billing_message;
    this.member_first_billing_message_date_of_month = data.member_first_billing_message_date_of_month;
    this.member_first_billing_message_time_of_day = data.member_first_billing_message_time_of_day;
    this.should_send_member_second_billing_message = data.should_send_member_second_billing_message;
    this.member_second_billing_message_date_of_month = data.member_second_billing_message_date_of_month;
    this.member_second_billing_message_time_of_day = data.member_second_billing_message_time_of_day;
    this.should_send_member_third_billing_message = data.should_send_member_third_billing_message;
    this.member_third_billing_message_date_of_month = data.member_third_billing_message_date_of_month;
    this.member_third_billing_message_time_of_day = data.member_third_billing_message_time_of_day;
    this.corporate_members_billing_date_of_month = data.corporate_members_billing_date_of_month;
    this.corporate_members_billing_time_of_day = data.corporate_members_billing_time_of_day;
    this.should_send_company_first_billing_message = data.should_send_company_first_billing_message;
    this.company_first_billing_message_date_of_month = data.company_first_billing_message_date_of_month;
    this.company_first_billing_message_time_of_day = data.company_first_billing_message_time_of_day;
    this.should_send_company_second_billing_message = data.should_send_company_second_billing_message;
    this.company_second_billing_message_date_of_month = data.company_second_billing_message_date_of_month;
    this.company_second_billing_message_time_of_day = data.company_second_billing_message_time_of_day;
    this.should_send_company_third_billing_message = data.should_send_company_third_billing_message;
    this.company_third_billing_message_date_of_month = data.company_third_billing_message_date_of_month;
    this.company_third_billing_message_time_of_day = data.company_third_billing_message_time_of_day;
    this.company_interim_statements_date_of_month = data.company_interim_statements_date_of_month;
    this.company_interim_statements_time_of_day = data.company_interim_statements_time_of_day;
    this.should_send_company_first_interim_statement_message = data.should_send_company_first_interim_statement_message;
    this.company_first_interim_statement_message_date_of_month = data.company_first_interim_statement_message_date_of_month;
    this.company_first_interim_statement_message_time_of_day = data.company_first_interim_statement_message_time_of_day;
    this.should_send_company_second_interim_statement_message = data.should_send_company_second_interim_statement_message;
    this.company_second_interim_statement_message_date_of_month = data.company_second_interim_statement_message_date_of_month;
    this.company_second_interim_statement_message_time_of_day = data.company_second_interim_statement_message_time_of_day;
    this.should_send_company_third_interim_statement_message = data.should_send_company_third_interim_statement_message;
    this.company_third_interim_statement_message_date_of_month = data.company_third_interim_statement_message_date_of_month;
    this.company_third_interim_statement_message_time_of_day = data.company_third_interim_statement_message_time_of_day;
    this.should_send_dependent_birthday_message = data.should_send_dependent_birthday_message;
    this.dependent_birthday_message_time_of_day = data.dependent_birthday_message_time_of_day;
    this.corporate_members_can_submit_claims = data.corporate_members_can_submit_claims;
    this.individual_members_can_submit_claims = data.individual_members_can_submit_claims;
    this.allows_individual_members_backdating = data.allows_individual_members_backdating;
    this.allows_corporate_members_backdating = data.allows_corporate_members_backdating;
    this.effective_date_cutoff_day_of_month = data.effective_date_cutoff_day_of_month;
    // Stage 5 PR 100 — lapsing controls.
    this.lapse_after_months = data.lapse_after_months;
    this.corporate_lapsing_auto_execute = data.corporate_lapsing_auto_execute;
    this.individual_lapsing_auto_execute = data.individual_lapsing_auto_execute;
    // Stage 2 PR 5 — copy-or-lose; same discipline as other fields.
    this.duplicate_claim_window_days = data.duplicate_claim_window_days;
    this.domain = data.domain;
    this.uuid = data.uuid;
    this.date_deleted = data.date_deleted;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;
  }
}
